import { render, staticRenderFns } from "./updateAccount.vue?vue&type=template&id=48efeb54"
import script from "./updateAccount.vue?vue&type=script&lang=js"
export * from "./updateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports